import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";

const AddNewAssistentes: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/assistentes/novo');
  };

  return (
    <button
      onClick={handleClick}
      className="border min-h-[40px] px-3 border-neutral-500 bg-neutral-600 hover:bg-neutral-500 rounded-[6px] flex justify-center items-center gap-2 transition-colors"
    >
      <p className="text-neutral-50 font-medium text-[14px]">Novo assistente</p>
      <Plus size={18} color="#71717A" />
    </button>
  );
};

export default AddNewAssistentes;
